"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencyFlagSizes;
(function (CurrencyFlagSizes) {
    CurrencyFlagSizes["SMALL"] = "sm";
    CurrencyFlagSizes["MEDIUM"] = "md";
    CurrencyFlagSizes["LARGE"] = "lg";
    CurrencyFlagSizes["XLARGE"] = "xl";
})(CurrencyFlagSizes = exports.CurrencyFlagSizes || (exports.CurrencyFlagSizes = {}));
